const getFn = (pattern) => function(target){
    return (
        pattern
            .replace(/{{prefix}}/g, target?.getAttribute?.('data-select-prefix')??'')
            .replace(/{{id}}/g, target?.getAttribute?.('id')??'')
            .replace(/{{name}}/g, target?.getAttribute?.('name')??'')
    )
}

const SELECT_NAME = getFn('{{prefix}}-{{name}}');
const SELECT_ID = getFn('{{prefix}}-{{id}}');

const SELECT = getFn('select[name="{{prefix}}-{{name}}"][id="{{prefix}}-{{id}}"]');

class MultiFileSelect {

    static init() {
        if (!MultiFileSelect.inited) {
            MultiFileSelect.inited = true;
            window.addEventListener('change', MultiFileSelect.change, true);
            window.addEventListener('click', MultiFileSelect.click, true);
// vyhodit, až se upraví form2 element ... RSP. bych to pro jistotu asi nechal, aby se v tom neudělala nějaká neplecha... //
            window.addEventListener('focus', MultiFileSelect.focus, true);
        }
    }

    static change(event) {
        let target;
        if (target = event?.target?.closest?.('input[type="file"][data-file-select]')) {
            MultiFileSelect.renderSelect(target);

        }
    }

// vyhodit, až se upraví form2 element ... RSP. bych to pro jistotu asi nechal, aby se v tom neudělala nějaká neplecha... //
    static focus(event) {
        let target;
        if (target = event?.target?.closest?.('input[type="file"][data-file-select][multiple]')) {
            target.removeAttribute('multiple');
        }
    }

    static click(event) {
        // vyhodit, až se upraví form2 element ... RSP. bych to pro jistotu asi nechal, aby se v tom neudělala nějaká neplecha... //
        MultiFileSelect.focus(event);
        let target;
        if (target = event?.target?.closest?.('.vut-file-btn-remove')) {
            let e;
            let vutfile = target.closest('.vut-file');
            let input = vutfile.querySelector('input[type="file"]');
            while (e = document.querySelector(SELECT(input))) { e.remove(); }
            if (/\[\]$/.test(input.name) && (document.querySelectorAll('input[type="file"][name="'+input.name+'"]').length > 1)) {
                // existuje více inputů se stejným name, odebrat
                vutfile.remove();
            }

        }
    }

    static makeSelect(target) {
        let data;
        try {
            data = JSON.parse(target.dataset.fileSelect);
        } catch(e) {
            console.error('FileSelect: neplatný json data atributu elementu ', target);
            throw 'Nelze vytvořit select.'
        }

        let select = document.createElement('select');
        select.className='form-control';
        select.name=SELECT_NAME(target);
        select.id=SELECT_ID(target);
        Object.keys(data).forEach((key)=>{
            let option = document.createElement('option');
            option.setAttribute('value', key);
            option.innerText = data[key];
            select.appendChild(option);
        })
        return select;
    }

    static renderSelect(target) {
        let name = Array.from(target.files).map((file) => file.name).join(', ');

        if (name) {

            let select = document.querySelector(SELECT(target));

            if (!select) {

                if (/\[\]$/.test(target.name)) {
                    // klonovat
                    let clone = target.closest('.vut-file').cloneNode(true);
                    clone.classList.add('js-file-select-clone');
                    let input = clone.querySelector('input[type="file"]');
                    let id = input.getAttribute('id');
                    let suffix = Math.abs(parseInt(id.match(/-\d+$/)?.[0] ?? 0) ?? 0);
                    id = id.replace(/-\d+$/, '');
                    while (document.querySelector('input[type="file"][id="' + (id + '-' + suffix) + '"]')) {
                        suffix++;
                    }
                    input.setAttribute('id', id + '-' + suffix);
                    input.insertAdjacentHTML('beforebegin', input.outerHTML);
                    input.remove();
                    target.closest('.vut-file').insertAdjacentElement('afterend', clone);
                    if (clone.querySelector('.bs_popover')) {
                        try {window.initPopover()} catch(e) {}
                    }
                }

                select = MultiFileSelect.makeSelect(target);
            }

            target.closest('.vut-file').insertAdjacentElement('afterend', select);

        } else {

            let e;
            while (e=document.querySelector(SELECT(target))) { e.remove(); }

            if (/\[\]$/.test(target.name) && (document.querySelectorAll('input[type="file"][name="'+target.name+'"]').length > 1)) {
                // existuje více inputů se stejným name, odebrat
                target.closest('.vut-file').remove();
            }

        }

    }


}

MultiFileSelect.init();